export const TRACK_EVENT_TYPES = {
  REGISTRATION_INITIATED: 'REGISTRATION_INITIATED',
  REGISTRATION_SUCCESS: 'REGISTRATION_SUCCESS',
  DMP_LOGIN: 'LOGIN_INITIATED',
  DMP_LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  SSO_LOGIN: 'SSO_LOGIN_INITIATED',
  SSO_LOGIN_SUCCESS: 'SSO_LOGIN_SUCCESS',
  LOGOUT: 'LOGOUT',
  DATASET_VIEW_OPEN: 'DATASET_VIEW_OPEN',
  CUSTOMER_DATASET_VIEW_OPEN: 'CUSTOMER_DATASET_VIEW_OPEN',
  DATASET_LOCAL_DOWNLOAD_INITIATED: 'DATASET_LOCAL_DOWNLOAD_INITIATED',
  DATASET_CLOUD_DOWNLOAD_INITIATED: 'DATASET_CLOUD_DOWNLOAD_INITIATED',
  FILE_PREVIEW_OPEN: 'FILE_PREVIEW_OPEN',
  ADD_TO_DATAHUB_SUCCESS: 'ADD_TO_DATAHUB_SUCCESS',
  SEARCH_IN_LANDING_PAGE: 'SEARCH_IN_LANDING_PAGE',
  FILTER_APPLIED_IN_LANDING_PAGE: 'FILTER_APPLIED_IN_LANDING_PAGE',
  DATASET_ENHANCEMENT_INITIATED: 'DATASET_ENHANCEMENT_INITIATED',
  DATASET_ENHANCEMENT_SUCCESS: 'DATASET_ENHANCEMENT_INITIATED_SUCCESS',
  DATASET_ENHANCEMENT_CANCELLED: 'DATASET_ENHANCEMENT_CANCELLED',
  CUSTOMER_DATASET_ENHANCEMENT_INITIATED: 'CUSTOMER_DATASET_ENHANCEMENT_INITIATED',
  CUSTOMER_DATASET_ENHANCEMENT_SUCCESS: 'CUSTOMER_DATASET_ENHANCEMENT_SUCCESS',
  CUSTOMER_DATASET_ENHANCEMENT_CANCELLED: 'CUSTOMER_DATASET_ENHANCEMENT_CANCELLED',
  GET_IN_TOUCH_CLICKED: 'GET_IN_TOUCH_CLICKED',
  GET_IN_TOUCH_REQUEST_INITIATED: 'GET_IN_TOUCH_REQUEST_INITIATED',
  GET_IN_TOUCH_REQUEST_SUBMITTED: 'GET_IN_TOUCH_REQUEST_SUBMITTED',
  GET_IN_TOUCH_REQUEST_CANCELLED: 'GET_IN_TOUCH_REQUEST_CANCELLED',
  ENHANCE_DATASET_REQUEST_CLICKED: 'ENHANCE_DATASET_REQUEST_CLICKED',
  CUSTOMER_ENHANCE_DATASET_REQUEST_CLICKED: 'CUSTOMER_ENHANCE_DATASET_REQUEST_CLICKED',
  NEW_DATASET_REQUEST_CLICKED: 'NEW_DATASET_REQUEST_CLICKED',
  NEW_DATASET_REQUEST_INITIATED: 'NEW_DATASET_REQUEST_INITIATED',
  NEW_DATASET_REQUEST_SUBMITTED: 'NEW_DATASET_REQUEST_SUBMITTED',
  NEW_DATASET_REQUEST_CANCELLED: 'NEW_DATASET_REQUEST_CANCELLED',
  CUSTOMER_UPLOAD_DATASET_CLICKED: 'CUSTOMER_UPLOAD_DATASET_CLICKED',
  CUSTOMER_UPLOAD_DATASET_INITIATED: 'CUSTOMER_UPLOAD_DATASET_INITIATED',
  CUSTOMER_UPLOAD_DATASET_SUBMITTED: 'CUSTOMER_UPLOAD_DATASET_SUBMITTED',
  CUSTOMER_UPLOAD_DATASET_CANCELLED: 'CUSTOMER_UPLOAD_DATASET_CANCELLED',
  CUSTOMER_DATASET_LOCAL_DOWNLOAD_INITIATED: 'CUSTOMER_DATASET_LOCAL_DOWNLOAD_INITIATED',
  CUSTOMER_DATASET_CLOUD_DOWNLOAD_INITIATED: 'CUSTOMER_DATASET_CLOUD_DOWNLOAD_INITIATED',
  CUSTOMER_DATASET_FILE_PREVIEW_OPEN: 'CUSTOMER_DATASET_FILE_PREVIEW_OPEN',
  PROVIDER_DATASET_LINK_CLICKED: 'PROVIDER_DATASET_LINK_CLICKED',
  DATASET_FILE_LOCAL_DOWNLOAD_INITIATED: 'DATASET_FILE_LOCAL_DOWNLOAD_INITIATED',
  DATASET_FILE_CLOUD_DOWNLOAD_INITIATED: 'DATASET_FILE_CLOUD_DOWNLOAD_INITIATED',
  CUSTOMER_DATASET_FILE_LOCAL_DOWNLOAD_INITIATED: 'CUSTOMER_DATASET_FILE_LOCAL_DOWNLOAD_INITIATED',
  CUSTOMER_DATASET_FILE_CLOUD_DOWNLOAD_INITIATED: 'CUSTOMER_DATASET_FILE_CLOUD_DOWNLOAD_INITIATED',
};
